// Sidebar imports
import {
  UilEstate,
  UilClipboardAlt,
  //UilUsersAlt,
  UilPackage,
  UilChart,
  //UilSignOutAlt,
  UilPen,
  UilFileAlt,UilPlusSquare,
  
  UilShoppingCart,
  UilSearch,
  UilListUl  
} from "@iconscout/react-unicons";
import axios from "axios";
import { useEffect,useState } from "react";
import { UilWebGrid } from '@iconscout/react-unicons';
// Analytics Cards imports
import { UilRefresh } from '@iconscout/react-unicons';
import { UilLayerGroup, UilApps,UilThLarge } from "@iconscout/react-unicons";

import { UilUsdSquare, UilMoneyWithdrawal } from "@iconscout/react-unicons";
//import { keyboard } from "@testing-library/user-event/dist/keyboard";
import { API_BASE } from '../utils/api';
// Recent Card Imports
// img1 from "../imgs/img1.png";
//import img2 from "../imgs/img2.png";
//import img3 from "../imgs/img3.png";
import { UilHistory } from '@iconscout/react-unicons';
import { UilUtensils } from '@iconscout/react-unicons';

export const SidebarData = [
  {
    icon: UilEstate,
    heading: "Dashboard",
    link:"/dashboard"
  },
  // {
  //   icon: UilPlusSquare,
  //   heading: "Add Restaurant",
  //   link: "/resturant/add"
  // },
  //   {
  //   icon: UilSearch,  
  //   heading: "Restaurant Details",
  //   link: "/resturant/details"
  // },
  
  {
    icon: UilClipboardAlt,
    heading: "Products",
    link:"/product"
  },
  {
    icon: UilLayerGroup,
    heading: "Category",
    link: "/categories"
  },
  {
    icon: UilApps,
    heading: "Subcategory",
    link: "/subcategories"
  },
  
  
  // {
  //   icon: UilChart,
  //   heading: 'Update',
  //   link:"/price-update",
  // },

  {
    icon: UilFileAlt,
    heading: "Report",  
   
    link: "/reports", 
  },
  {
    icon:UilWebGrid ,
    heading: 'Banner',
    link:"/banner"
  },
  
  {
    icon:UilListUl,
    heading: 'Order Management',
    link:"/order"
  },
     {
    icon:UilThLarge,
    heading: 'Inventory Management',
    link:"/inventory"
  },
  // {
  //   icon: UilUtensils,
  //   heading: 'Dine-in',
  //   link: "/dining"
  // },
  // {
  //   icon: UilPen,
  //   heading: 'Feedback',
  //   link:"/userfeedback",
  // },
  // {
  //   icon: UilPen,
  //   heading: 'Feedback1',
  //   link:"/feedback1",
  // },
  {
    icon: UilHistory,
    heading: 'Change Password',
    link:"/change-password",
  },


];
export const useDashboardData = () => {
  const [cardsData, setCardsData] = useState([
    {
      title: "Total Orders",
      color: {
        backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
        boxShadow: "0px 10px 20px 0px #e0c6f5",
      },
      png: UilUsdSquare,
      series: [{ name: "Sales", data: [0] }],
    },
    {
      title: "Monthly Orders",
      color: {
        backGround: "linear-gradient(180deg, #FF919D 0%, #FC929D 100%)",
        boxShadow: "0px 10px 20px 0px #FDC0C7",
      },
      png: UilMoneyWithdrawal,
      series: [{ name: "Revenue", data: [0] }],
    },
    {
      title: "Completed Orders",
      color: {
        backGround: "linear-gradient(rgb(235, 189, 115) -146.42%, rgb(255 202 113) -46.42%)",
        boxShadow: "0px 10px 20px 0px rgb(249, 213, 155)",
      },
      png: UilClipboardAlt,
      series: [{ name: "Completed", data: [0] }],
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
      
        const response = await axios.get(`${API_BASE}/api/orders/order-stats`);

        
        const { totalOrders, monthlyOrders, completedOrders } = response.data;

   

       
        setCardsData(prevData => {
          return prevData.map((card, index) => {
              let newData = [];
              if (index === 0) newData = [totalOrders];     
              else if (index === 1) newData = [monthlyOrders]; 
              else if (index === 2) newData = [completedOrders];
      
              return {
                  ...card,
                  series: [{ name: card.title, data: newData }]
              };
          });
      });
      

        

      } catch (error) {
        // console.error("Error fetching order data:", error);
      }
    };

    fetchData();
  }, []); 
  
 

  return cardsData;
};


  